module.exports = "<router-outlet></router-outlet>\n<app-toaster-container [toasterconfig]=\"toasterConfig\"></app-toaster-container>\n"